export const getTenantFromHostname = (): string =>
  window.location.hostname.split(".")[0];

/**
 * Checks if the requested tenant is allowed based on the JWT tenant claims
 * @param requestedTenant - The tenant name from the URL/hostname
 * @param jwtTenants - Array of tenant claims from the JWT token
 * @returns boolean indicating if access is allowed
 */
export const checkTenantAllowed = (
  requestedTenant: string,
  jwtTenants: string[] | undefined
): boolean => {
  if (!jwtTenants || !requestedTenant) {
    return false;
  }

  if (jwtTenants.includes("*")) {
    return true;
  }

  return jwtTenants.includes(requestedTenant);
};
